import React, { Component } from 'react';
import PropTypes from 'prop-types';
import CloseModalSvg from './CloseModalSvg';
import classnames from 'classnames';
import moment from 'moment';
import 'moment-timezone';
import './Modal.sass';
import Mapbox from '../../Mapbox';
import get from 'lodash/get';

const DAY_MAP = [
  'sunday',
  'monday',
  'tuesday',
  'wednesday',
  'thursday',
  'friday',
  'saturday',
];
const dayOrd = new Date().getDay();
const CURRENT_DAY = DAY_MAP[dayOrd];
const renderHoursRange = (dayHours) => {
  const hours = dayHours[0]
  if (hours) {
    const open = hours[0]
    let close = hours[1]
    if (close === '23:59') {
      close = '00:00'
    }
    const openMoment = moment.utc('2016-01-01T'+open+'Z')
    const closeMoment = moment.utc('2016-01-01T'+close+'Z')
    const openAt  = openMoment.format('h:mma')
    const closeAt = closeMoment.format('h:mma')
    return openAt + '-' + closeAt
  }
  return 'closed';
}
const openNow = (dayHours, timezone) => {
  const hours = dayHours[0]
  if (hours) {
    const open = moment(hours[0], 'HH:mm').tz(timezone);
    const close = moment(hours[1], 'HH:mm').tz(timezone);
    const nowHour = moment();
    if (nowHour >= open && nowHour <= close) {
      return true
    }
  }
  return false
}

class DeliveryModal extends Component {
  render() {
    const {
      onRequestHide,
      selectedKitchen,
      kitchens,
      onSelect,
      onClick,
      menuLink,
      announcement,
    } = this.props;
    const hours = selectedKitchen.hours
    const timezone = selectedKitchen.timezone;
    const isOpen = hours ? openNow(hours[CURRENT_DAY], timezone) : false;
    const openClosed = isOpen ? 'OPEN NOW' : 'CLOSED';
    const kitchen = selectedKitchen || kitchens[0];
    const deliveryAreas = get(kitchen, 'delivery_areas');
    const kitchenLocation = get(kitchen, 'location', {});

    return (
      <div className="home-modal">
        <div className="home-modal-inner">
            <div className="close" onClick={onRequestHide}>
              <CloseModalSvg/>
            </div>
            {announcement ?
              <div className='modal-status-wrapper'>
                  <div className="modal-status">
                      <p className='full-msg'>{announcement}</p>
                  </div>
              </div> : null}
            <div className="home-modal-header">
                <h3>Delivery Locations</h3>
                <select onChange={onSelect}>
                    {kitchens.map(kitchen => {
                      const selected = selectedKitchen.id === kitchen.id
                      return <option key={kitchen.id} value={kitchen.id} {...{ selected }}>{kitchen.name}</option>
                    })}
                </select>
                <div className="options">
                  {kitchens.map(kitchen => {
                    return (
                      <div className={classnames("option", {active: selectedKitchen.id === kitchen.id})}    onClick={e => onClick(kitchen)} key={kitchen.id}>
                        <div className="title">{kitchen.name}</div>
                        <svg xmlns="http://www.w3.org/2000/svg" width="9" height="14" viewBox="273 205 9 14"><polygon points="273.1 217.1 274.9 218.9 281.8 212 274.9 205.1 273.1 206.9 278.2 212" fill="#525861"/></svg>
                      </div>
                    )
                  })}
                </div>
            </div>

            <div className="home-modal-content">
                <h3>{ selectedKitchen.name}</h3>
                <a className="menu-link" href={menuLink}>View Menu</a>
                <hr />

                {hours ? <div className="hours-listing">
                    <div className="hours-listing-label">
                        <div className={classnames('indicator', {closed: !isOpen})}></div>
                        <b>{openClosed}:</b> {renderHoursRange(hours[CURRENT_DAY])}

                        <ul>
                            <li><b>MON:</b> <span>{renderHoursRange(hours.monday)}</span></li>
                            <li><b>TUE:</b> <span>{renderHoursRange(hours.tuesday)}</span></li>
                            <li><b>WED:</b> <span>{renderHoursRange(hours.wednesday)}</span></li>
                            <li><b>THU:</b> <span>{renderHoursRange(hours.thursday)}</span></li>
                            <li><b>FRI:</b> <span>{renderHoursRange(hours.friday)}</span></li>
                            <li><b>SAT:</b> <span>{renderHoursRange(hours.saturday)}</span></li>
                            <li><b>SUN:</b> <span>{renderHoursRange(hours.sunday)}</span></li>
                        </ul>
                    </div>
                </div> : null}
                <Mapbox
                  showDeliveryAreas={true}
                  showNavControls={true}
                  kitchenInZone={false}
                  showDestMarker={false}
                  height={400}
                  {...{
                    deliveryAreas,
                    kitchenLocation
                  }} />
            </div>
        </div>
      </div>
    );
  }
}

DeliveryModal.propTypes = {
  onRequestHide: PropTypes.func.isRequired,
  onSelect: PropTypes.func.isRequired,
  onClick: PropTypes.func.isRequired,
  selectedKitchen: PropTypes.shape({
    id: PropTypes.string,
    name: PropTypes.string,
    hours: PropTypes.object,
    timezone: PropTypes.string,
  }),
  kitchens: PropTypes.array,
  menuLink: PropTypes.string,
};

export default DeliveryModal;
